import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AcknowledgeDialogComponent } from '../acknowledge-dialog/acknowledge-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { UserService } from '../../services/user.service';

interface InactiveUserItem { email: string; userId: string; lastLoginDate: string; }

@Component({
  selector: 'app-inactive-users-admin',
  templateUrl: './inactive-users-admin.component.html',
  styleUrls: ['./inactive-users-admin.component.scss']
})
export class InactiveUsersAdminComponent {
  // default = today-1y at frontend local time, but we will send as YYYY-MM-DD
  targetDate: string;
  items: InactiveUserItem[] = [];
  loading = false;
  listed = false;

  constructor(private dialog: MatDialog, private userService: UserService) {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    this.targetDate = d.toISOString().substring(0, 10); // YYYY-MM-DD
  }

  // Sync from Auth0
  onSyncNow(): void {
    this.loading = true;
    this.userService.syncUsersLastLogin().subscribe({
      next: (res) => {
        this.loading = false;
        this.dialog.open(AcknowledgeDialogComponent, { data: `Sync completed: updated ${res?.updated ?? 0}, skipped ${res?.skipped ?? 0}, failed ${res?.failed ?? 0}.` });
        // auto refresh list using current date selection
        this.onList();
      },
      error: (err) => {
        this.loading = false;
        this.dialog.open(AcknowledgeDialogComponent, { data: `Sync failed: ${err?.error?.error || err.message}` });
      }
    });
  }

  // List inactive users
  onList(): void {
    this.loading = true;
    this.userService.listInactiveUsers(this.targetDate).subscribe({
      next: (rows) => {
        this.items = (rows || []).map((r: any) => ({ email: r.email, userId: r.userId, lastLoginDate: r.lastLoginDate }));
        this.loading = false;
        this.listed = true;
      },
      error: (err) => {
        this.loading = false;
        this.listed = true;
        this.dialog.open(AcknowledgeDialogComponent, { data: `List failed: ${err?.error?.error || err.message}` });
      }
    });
  }

  // Delete inactive users with two-level confirmation (type DELETE)
  onDelete(): void {
    // 1st: show count
    this.userService.countInactiveUsers(this.targetDate).subscribe({
      next: (r) => {
        const count = r?.count ?? 0;
        const ref1 = this.dialog.open(ConfirmDialogComponent, {
          width: '420px',
          data: { title: 'Confirm Deletion', message: `You are about to delete ${count} user(s). Continue?` }
        });
        ref1.afterClosed().subscribe(first => {
          if (!first) { return; }
          // 2nd: require typing DELETE
          const ok = window.prompt(`Type DELETE to confirm deleting ${count} user(s):`);
          if (ok !== 'DELETE') { return; }
          this.loading = true;
          this.userService.deleteInactiveUsers(this.targetDate).subscribe({
            next: (res) => {
              this.loading = false;
              this.dialog.open(AcknowledgeDialogComponent, { data: `Deleted ${res?.deleted ?? 0} user(s).` });
              this.onList();
            },
            error: (err) => {
              this.loading = false;
              this.dialog.open(AcknowledgeDialogComponent, { data: `Delete failed: ${err?.error?.error || err.message}` });
            }
          });
        });
      },
      error: (err) => this.dialog.open(AcknowledgeDialogComponent, { data: `Count failed: ${err?.error?.error || err.message}` })
    });
  }
}
